import { render } from "./EqtlTableDescription.vue?vue&type=template&id=0c5d08c7"
import script from "./EqtlTableDescription.vue?vue&type=script&lang=js"
export * from "./EqtlTableDescription.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__